import { Modal, Row, Col } from "antd";
import { Flex, Box } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import Field from "components/Input/Field/index";
import { Checkbox } from "@chakra-ui/react";
import SelectImpostos from "components/Input/SelectImpostos/index";
import { RetencaoImpostoItem } from "core/features/conta/typings/index";
import { useEffect } from "react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import PrimaryButton from "components/Button/PrimaryButton";
import moment from "moment";
import InputCalcular from "ui/components/Input/InputCalcular";

interface ModalRetencaoImpostoProps {
  open: boolean;
  onClose: () => any;
  isEdit?: boolean;
  onSubmit: (item: RetencaoImpostoItem) => any;
  defaultData?: Partial<RetencaoImpostoItem>;
  total: number;
}

const defaultValues: RetencaoImpostoItem = {
  codigoBarras: "",
  complemento: "",
  impostoId: "",
  reterImposto: false,
  dataVencimento: moment().format("YYYY-MM-DD"),
  valor: 0,
};

export default function ModalRetencaoImposto({
  onClose,
  open,
  isEdit,
  onSubmit,
  defaultData,
  total,
}: ModalRetencaoImpostoProps) {
  const { control, reset, handleSubmit, setValue, watch } =
    useForm<RetencaoImpostoItem>({
      defaultValues,
    });

  const form = watch();
  useEffect(() => {
    if (open) {
      reset({
        ...defaultValues,
        ...defaultData,
      });
    }
  }, [defaultData, open, reset]);

  const valor = form.imposto?.aliquota
    ? total * (form.imposto?.aliquota / 100)
    : 0;

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      destroyOnClose
      width="900px"
      title={`${isEdit ? "Editar" : "Adicionar"} Retenção  de Impostos`}
      footer={
        <Flex justifyContent="end">
          <CloseModalButton close={onClose} closeModalLabel="Cancelar" />
          <PrimaryButton ml={5} mr={2} onClick={handleSubmit(onSubmit)}>
            Adicionar
          </PrimaryButton>
        </Flex>
      }
    >
      <Box as={Row} mb={4} gutter={16}>
        <Box as={Col} md={9}>
          <Field
            control={control}
            name={`impostoId`}
            label="Imposto"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <SelectImpostos
                placeholder="Selecione o imposto"
                value={field.value}
                onChange={(v, option) => {
                  field.onChange(v);
                  setValue("imposto", option as any);
                }}
                isInvalid={isInvalid}
              />
            )}
          />
        </Box>
        <Box as={Col} md={6}>
          <Field
            control={control}
            name={`valor`}
            label="Valor"
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <InputCalcular
                value={field.value}
                valorCalculado={valor}
                onChange={field.onChange}
              />
            )}
          />
        </Box>
        <Box as={Col} md={5}>
          <Field
            control={control}
            name={`dataVencimento`}
            label="Vencimento"
            rules={{
              required: true,
            }}
            inputProps={{ type: "date" }}
          />
        </Box>
        <Box as={Col} md={4}>
          <Field
            control={control}
            name={`reterImposto`}
            render={({ field, isInvalid }) => (
              <Checkbox
                mt={7}
                isChecked={field.value}
                isInvalid={isInvalid}
                onChange={() => {
                  field.onChange(!field.value);
                }}
              >
                Reter imposto
              </Checkbox>
            )}
          />
        </Box>
      </Box>
      <Box as={Row} mb={4} gutter={16}>
        <Box as={Col} md={9}>
          <Field control={control} name={`complemento`} label="Complemento" />
        </Box>
        <Box as={Col} md={15}>
          <Field
            control={control}
            name={`codigoBarras`}
            label="Código de barras"
          />
        </Box>
      </Box>
    </Modal>
  );
}
